import { render, staticRenderFns } from "./InfoEditRegulation.vue?vue&type=template&id=1c625164&"
import script from "./InfoEditRegulation.js?vue&type=script&lang=js&"
export * from "./InfoEditRegulation.js?vue&type=script&lang=js&"
import style0 from "./InfoEditRegulation.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports